module.exports = __webpack_public_path__ + "static/18d8c9afa56fd92cc5cac5b375a57cc29223a7b04b8232beb62353a02eb030dd-b54d6d6789bf2c6f3b2a129b716b1c6e.jpeg";